var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAuthenticationicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_38_8)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_38_8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.4062 18.4326L20.5444 14.2944L21.6431 15.3931L16.4062 20.6299L13.5132 17.7368L14.6118 16.6382L16.4062 18.4326ZM25 9.375V25H9.375V15.4663C8.87858 15.5721 8.35775 15.625 7.8125 15.625C6.73014 15.625 5.71696 15.4215 4.77295 15.0146C3.82894 14.6077 2.99886 14.0503 2.28271 13.3423C1.56657 12.6343 1.00911 11.8083 0.610352 10.8643C0.211589 9.92025 0.00813802 8.90299 0 7.8125C0 6.73014 0.203451 5.71696 0.610352 4.77295C1.01725 3.82894 1.57471 2.99886 2.28271 2.28271C2.99072 1.56657 3.81673 1.00911 4.76074 0.610352C5.70475 0.211589 6.72201 0.00813802 7.8125 0C8.89486 0 9.90804 0.203451 10.8521 0.610352C11.7961 1.01725 12.6261 1.57471 13.3423 2.28271C14.0584 2.99072 14.6159 3.81673 15.0146 4.76074C15.4134 5.70475 15.6169 6.72201 15.625 7.8125C15.625 8.35775 15.5721 8.87858 15.4663 9.375H25ZM1.5625 7.8125C1.5625 8.67513 1.72526 9.48486 2.05078 10.2417C2.3763 10.9985 2.82389 11.6577 3.39355 12.2192C3.96322 12.7808 4.62646 13.2284 5.3833 13.562C6.14014 13.8957 6.94987 14.0625 7.8125 14.0625C8.67513 14.0625 9.48486 13.8997 10.2417 13.5742C10.9985 13.2487 11.6577 12.8011 12.2192 12.2314C12.7808 11.6618 13.2284 10.9985 13.562 10.2417C13.8957 9.48486 14.0625 8.67513 14.0625 7.8125C14.0625 6.94987 13.8997 6.14014 13.5742 5.3833C13.2487 4.62646 12.8011 3.96729 12.2314 3.40576C11.6618 2.84424 10.9985 2.39665 10.2417 2.06299C9.48486 1.72933 8.67513 1.5625 7.8125 1.5625C6.94987 1.5625 6.14014 1.72526 5.3833 2.05078C4.62646 2.3763 3.96729 2.82389 3.40576 3.39355C2.84424 3.96322 2.39665 4.62646 2.06299 5.3833C1.72933 6.14014 1.5625 6.94987 1.5625 7.8125ZM23.4375 10.9375H14.978C14.563 11.8571 14.0177 12.6546 13.3423 13.3301C12.6668 14.0055 11.8652 14.5549 10.9375 14.978V23.4375H23.4375V10.9375ZM12.2681 6.01807L7.03125 11.2549L4.13818 8.36182L5.23682 7.26318L7.03125 9.05762L11.1694 4.91943L12.2681 6.01807Z",
    fill: "#27b74e"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_38_8",
    x: -4,
    y: -4,
    width: 33,
    height: 33,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.229167 0 0 0 0 0.229167 0 0 0 0 0.229167 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_38_8"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_38_8",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_38_8"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthenticationicon);
export default __webpack_public_path__ + "static/media/authenticationicon.503ab5d11fac25862423adf9cb578aee.svg";
export { ForwardRef as ReactComponent };